/** Shared catalog categories (Item Management + home browsing). */
import { brandColors, brandGradientPairs } from "./brandTheme";

const g = (index) => brandGradientPairs[index % brandGradientPairs.length];

export const PRODUCT_CATEGORIES = [
  {
    name: "Electronics",
    shortLabel: "Electronics",
    imageKey: "electronics",
    tagline: "Smart gadgets and everyday tech, curated for you.",
    gradient: g(0),
  },
  {
    name: "Clothing",
    shortLabel: "Fashion",
    imageKey: "clothing",
    tagline: "Fresh styles and comfortable fits are on the way.",
    gradient: g(1),
  },
  {
    name: "Home & Garden",
    shortLabel: "Home",
    imageKey: "home-garden",
    tagline: "Make every corner of your home feel special.",
    gradient: g(2),
  },
  {
    name: "Sports & Outdoors",
    shortLabel: "Sports",
    imageKey: "sports",
    tagline: "Gear up for your next adventure soon.",
    gradient: g(3),
  },
  {
    name: "Books & Media",
    shortLabel: "Books",
    imageKey: "books",
    tagline: "Stories, learning, and entertainment—arriving shortly.",
    gradient: g(4),
  },
  {
    name: "Health & Beauty",
    shortLabel: "Beauty",
    imageKey: "beauty",
    tagline: "Wellness and self-care picks are being prepared.",
    gradient: g(5),
  },
  {
    name: "Toys & Games",
    shortLabel: "Toys",
    imageKey: "toys",
    tagline: "Fun for every age group—launching soon.",
    gradient: g(6),
  },
  {
    name: "Ticket Booking",
    shortLabel: "Ticket Booking",
    imageKey: "ticket-booking",
    tagline: "Events, travel, and experiences—bookings opening soon.",
    gradient: g(7),
  },
  {
    name: "Food & Beverages",
    shortLabel: "Food",
    imageKey: "food",
    tagline: "Pantry favorites and treats—coming to your cart soon.",
    gradient: g(0),
  },
  {
    name: "Jewelry & Accessories",
    shortLabel: "Jewelry",
    imageKey: "jewelry",
    tagline: "Sparkle and statement pieces are almost here.",
    gradient: g(1),
  },
  {
    name: "Baby & Kids",
    shortLabel: "Kids",
    imageKey: "kids",
    tagline: "Gentle, safe products for little ones—stay tuned.",
    gradient: g(2),
  },
  {
    name: "Pet Supplies",
    shortLabel: "Pets",
    imageKey: "pets",
    tagline: "Tail-wagging essentials are on their way.",
    gradient: g(3),
  },
  {
    name: "Industrial & Scientific",
    shortLabel: "Industrial",
    imageKey: "industrial",
    tagline: "Professional-grade supplies—listing soon.",
    gradient: g(4),
  },
  {
    name: "Arts & Crafts",
    shortLabel: "Arts",
    imageKey: "arts",
    tagline: "Creative kits and supplies are being sourced.",
    gradient: g(5),
  },
  {
    name: "Office Supplies",
    shortLabel: "Office",
    imageKey: "office",
    tagline: "Desk upgrades and stationery—coming soon.",
    gradient: g(6),
  },
  {
    name: "Musical Instruments",
    shortLabel: "Music",
    imageKey: "music",
    tagline: "Instruments and gear for every musician.",
    gradient: g(7),
  },
  {
    name: "Tools & Hardware",
    shortLabel: "Tools",
    imageKey: "tools",
    tagline: "Build, fix, and create—tooling up shortly.",
    gradient: g(0),
  },
  {
    name: "Furniture",
    shortLabel: "Furniture",
    imageKey: "furniture",
    tagline: "Comfort and design for every room—almost ready.",
    gradient: g(1),
  },
  {
    name: "Kitchen & Dining",
    shortLabel: "Kitchen",
    imageKey: "kitchen",
    tagline: "Cook, serve, and gather—kitchen picks en route.",
    gradient: g(2),
  },
  {
    name: "Personal Care",
    shortLabel: "Care",
    imageKey: "care",
    tagline: "Daily rituals made better—launching soon.",
    gradient: g(3),
  },
  {
    name: "Other",
    shortLabel: "More",
    imageKey: "other",
    tagline: "Surprise finds and unique items—watch this space.",
    gradient: [brandColors.backgroundAlt, brandColors.cyanLight],
  },
];

export const ALL_CATEGORIES_LABEL = "All";

/** Firestore / legacy labels mapped to current category names */
export const CATEGORY_LEGACY_ALIASES = {
  Automotive: "Ticket Booking",
};

export function canonicalCategoryName(name) {
  if (!name) return name;
  return CATEGORY_LEGACY_ALIASES[name] || name;
}

export function categoryMatchesFilter(itemCategory, selectedCategory) {
  if (!itemCategory || !selectedCategory) return false;
  return (
    canonicalCategoryName(itemCategory).toLowerCase() ===
    canonicalCategoryName(selectedCategory).toLowerCase()
  );
}

export const PRODUCT_CATEGORY_NAMES = PRODUCT_CATEGORIES.map((c) => c.name);

/** NavBar / filter dropdown options */
export const NAV_CATEGORIES = [ALL_CATEGORIES_LABEL, ...PRODUCT_CATEGORY_NAMES];

export function getCategoryMeta(name) {
  if (name === ALL_CATEGORIES_LABEL) {
    return {
      name: ALL_CATEGORIES_LABEL,
      shortLabel: "All",
      imageKey: "all",
      tagline: "Browse everything in our catalog.",
      gradient: [brandColors.navyMid, brandColors.sky],
    };
  }
  const canonical = canonicalCategoryName(name);
  return (
    PRODUCT_CATEGORIES.find(
      (c) => c.name.toLowerCase() === String(canonical || "").toLowerCase()
    ) || null
  );
}
